import { render, staticRenderFns } from "./StepProgramParticipants.vue?vue&type=template&id=38cf1a37&scoped=true"
import script from "./StepProgramParticipants.vue?vue&type=script&lang=js"
export * from "./StepProgramParticipants.vue?vue&type=script&lang=js"
import style0 from "./StepProgramParticipants.vue?vue&type=style&index=0&id=38cf1a37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cf1a37",
  null
  
)

export default component.exports